import { memo } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqItems = [
  {
    question: "Wat kost een Shopify webshop laten maken?",
    answer:
      "Een Shopify webshop bij Nextconvert kost tussen de €1.000 en €5.000. De exacte prijs hangt af van het aantal producten, gewenste functionaliteiten en maatwerk design. Je krijgt altijd een vaste prijs vooraf — geen verrassingen achteraf. Plan een gratis gesprek en ontvang binnen 24 uur een heldere offerte.",
  },
  {
    question: "Hoe lang duurt het bouwen van onze webshop?",
    answer:
      "De meeste webshops zijn binnen 14 tot 21 dagen live. Na de intake starten wij direct en je wordt wekelijks bijgehouden over de voortgang. Geen maanden wachten — jij wil verkopen, niet wachten.",
  },
  {
    question: "Kunnen wij na de oplevering zelf aanpassingen doen?",
    answer:
      "Ja. Shopify is ontworpen zodat jij als eigenaar eenvoudig producten, teksten en afbeeldingen kunt aanpassen — zonder technische kennis. Wij leveren je webshop op met een persoonlijke video-uitleg zodat je direct zelfstandig verder kunt.",
  },
  {
    question: "Wij hebben al een webshop. Kunnen jullie die verbeteren of migreren?",
    answer:
      "Absoluut. Veel klanten komen met een bestaande webshop die te weinig verkoopt. Wij analyseren waar conversie verloren gaat en pakken dat aan — of migreren je volledig naar een snellere, beter converterende Shopify shop. Plan een gratis gesprek en wij geven je direct inzicht in wat er beter kan.",
  },
  {
    question: "Wat gebeurt er na de oplevering?",
    answer:
      "Je webshop live = het begin, niet het einde. Wij bieden maandelijkse groei-abonnementen aan waarbij wij je webshop blijven optimaliseren, e-mailmarketing inzetten via Klaviyo en technisch onderhoud verzorgen. Zo groeit je omzet ook na de livegang door.",
  },
  {
    question: "Waarom Shopify en niet WooCommerce of een andere oplossing?",
    answer:
      "Shopify is het snelste, meest betrouwbare e-commerce platform voor ondernemers die willen groeien. Geen technisch gedoe, altijd stabiel, en schaalbaar van 10 naar 10.000 bestellingen per maand. Voor serieuze webshops is het simpelweg de beste keuze.",
  },
  {
    question: "Hoe werkt het kennismakingsgesprek?",
    answer:
      "Het kennismakingsgesprek is gratis en duurt ongeveer 30 minuten. We bespreken jouw producten, doelgroep en doelen. Daarna ontvang je een concreet voorstel met aanpak en prijs. Geen verplichtingen, wel direct duidelijkheid.",
  },
];

const ShopifyFAQ = () => {
  return (
    <section className="bg-primary px-4 md:px-12 py-16 md:py-24 w-full">
      <div className="max-w-[1100px] mx-auto">
        {/* Header - centered */}
        <div className="mb-10 md:mb-14 max-w-[860px] mx-auto text-center">
          <h2 className="text-white text-3xl md:text-4xl lg:text-[2.5rem] leading-[1.15] mb-5">
            Antwoorden op de <span className="text-accent">vragen</span> <span className="accent-serif whitespace-nowrap">die je nu hebt</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg leading-relaxed">
            Alles wat je wil weten voordat we samen een Shopify webshop bouwen. Helder, eerlijk en zonder verkoopverhaal.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="w-full space-y-3 md:space-y-4">
          {faqItems.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-cream rounded-2xl border-0 px-6 md:px-8"
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-primary py-5 md:py-6 hover:no-underline [&>svg]:text-primary [&>svg]:h-5 [&>svg]:w-5 [&>svg]:opacity-100">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-primary/70 text-sm md:text-base leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default memo(ShopifyFAQ);
